/*********************************************/
// Entry-Point der JavaScript-Anwendung
// Dieses Script wird über Webpack gebündelt
/*********************************************/

// === Module: Globale Imports ===
import 'intro.js/minified/introjs.min.css';
import * as bootstrap from 'bootstrap';
import * as $ from 'jquery';
import * as jQuery from 'jquery';

// Utility-Module als Namespace (weil viele Funktionen)
import * as utils from './components/utils';
import * as cookies from './components/cookies';
import * as flashToast from './components/flashToasts';

import * as Cropper from 'cropperjs';
import SignaturePad from 'signature_pad';
import * as bootbox from 'bootbox';
import * as whatsNew from './components/whatsNew';

// Spezifische Funktionen als Named Imports (besser für Tree-Shaking)
import {initThemeSwitch} from './components/themeSwitch';
import {initTooltips} from './pluginInits/init_tooltip';
import {initTextareaAutoHeight} from './components/textareaAutoHeight';
import {startTour} from './pluginInits/init_intro';
import {initBootboxButtons} from './pluginInits/init_bootbox';
import TomSelect from 'tom-select';
import {initTomSelect} from './pluginInits/init_tomSelect';


import ImageCropper from './classes/ImageCropper';
import {initNavigationWithOffcanvas} from "./pluginInits/init_navigationWithOffcanvas";

import {Html5Qrcode} from 'html5-qrcode';

// === Globals: Fensterobjekt erweitern ===
window.bootstrap = bootstrap;
window.$ = $;
window.jQuery = jQuery;
window.utils = utils;
window.cookies = cookies;
window.flashToast = flashToast;
window.Cropper = Cropper;
window.SignaturePad = SignaturePad;
window.bootbox = bootbox;
window.whatsNew = whatsNew;

window.TomSelect = TomSelect;

window.ImageCropper = ImageCropper;
window.Html5Qrcode = Html5Qrcode;

/*********************************************/
// Initialisierung der Anwendung
/*********************************************/
const SCRIPT_NAME = 'index.js';

/*********************************************/
// GUIDE TUTORIAL
/*********************************************/

//definieren der aktiven Seiten wo ein Guide ausgegeben werden soll
const ACTIVE_GUIDE_PAGES = [
    "dashboard", "dailyChecklists", "analyses", "charts", "documents",
    "taskmanager", "controlObject", "users", "userGroups", "object", "auditTrail", "tickets", 'reports', 'modulemanager', 'lilianLabsMapping'
];
const INTRO_JS_TOUR_BUTTON_SELECTOR = '[data-intro-js-tour-element-to-trigger="startTour"]';
const INTRO_JS_TOUR_ELEMENTS_SELECTOR = '[data-intro-js-tour]';

// Tom-Select
const TOM_SELECT_SELECTOR = '[data-tomSelect]';


/*####################################################################################*/
// INITIALISIERUNG ALLER SKRIPTE
/*####################################################################################*/

// DOMContent-Loaded Initialisierung
document.addEventListener('DOMContentLoaded', () => {

    initThemeSwitch();
    initNavigationWithOffcanvas();
    handleIntroJsTour();
    initTextareaAutoHeight();
    initTooltips();
    initTomSelect(TOM_SELECT_SELECTOR);
    initBootboxButtons();
    flashToast.initializeToasts();
});


/*********************************************/
// Funktion: Intro.js Tour initialisieren
/*********************************************/
function handleIntroJsTour() {
    const introJsTourButton = document.querySelector(INTRO_JS_TOUR_BUTTON_SELECTOR);
    const introJsTourElements = document.querySelectorAll(INTRO_JS_TOUR_ELEMENTS_SELECTOR);

    if (introJsTourElements.length > 0) {
        registerIntroJsTourButton(introJsTourButton, ACTIVE_GUIDE_PAGES);
        utils.consoleLog(SCRIPT_NAME, 'Intro.js Tour initialisiert', introJsTourElements);
    } else {
        disableIntroJsTourButton(introJsTourButton);
    }
}

function registerIntroJsTourButton(tourButton, guidePages) {
    if (tourButton) {
        utils.consoleLog(SCRIPT_NAME, 'Tour-Button gefunden, registriere Click-Event');
        tourButton.addEventListener('click', () => startTour(guidePages));
    } else {
        utils.consoleLog(SCRIPT_NAME, 'Tour-Button nicht gefunden');
    }
}

function disableIntroJsTourButton(tourButton) {
    if (tourButton) {
        tourButton.classList.add('disabled');
        tourButton.setAttribute('data-intro-js-tour-element-to-trigger', 'disabled');
    }
    utils.consoleLog(SCRIPT_NAME, 'Intro.js Tour Button deaktiviert.');
}
